// extracted by mini-css-extract-plugin
export default {"tooltip":"tooltip-BPyPvN","title":"title-WSHQYW"};